import React, { Component } from "react";
import { ReactComponent as ScreenIcon1 } from "assets/icons/screens-icon_1.svg";
import { ReactComponent as ScreenIcon2A } from "assets/icons/screens-icon_2a.svg";
import { ReactComponent as ScreenIcon2B } from "assets/icons/screens-icon_2b.svg";
import { ReactComponent as ScreenIcon3A } from "assets/icons/screens-icon_3a.svg";
import { ReactComponent as ScreenIcon3B } from "assets/icons/screens-icon_3b.svg";
import { ReactComponent as ScreenIcon3C } from "assets/icons/screens-icon_3c.svg";
import { ReactComponent as ScreenIcon3D } from "assets/icons/screens-icon_3d.svg";
import { ReactComponent as ScreenIcon4 } from "assets/icons/screens-icon_4.svg";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-2.svg";
import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";

import { withNamespaces } from "react-i18next";

import "component/menu/GamesLayout/styles.scss";

export const GamesLayoutType = {
  LAYOUT_1: "layout_1",
  LAYOUT_2A: "layout_2a",
  LAYOUT_2B: "layout_2b",
  LAYOUT_3A: "layout_3a",
  LAYOUT_3B: "layout_3b",
  LAYOUT_3C: "layout_3c",
  LAYOUT_3D: "layout_3d",
  LAYOUT_4: "layout_4",
};

class GamesLayout extends Component {
  constructor(props) {
    super(props);
    this.getSelectedIcon = this._getSelectedIcon.bind(this);
    this.state = {
      collapse: true,
    };
  }

  _getSelectedIcon(layout) {
    switch (layout) {
      case GamesLayoutType.LAYOUT_2A:
        return <ScreenIcon2A />;
      case GamesLayoutType.LAYOUT_2B:
        return <ScreenIcon2B />;
      case GamesLayoutType.LAYOUT_3A:
        return <ScreenIcon3A />;
      case GamesLayoutType.LAYOUT_3B:
        return <ScreenIcon3B />;
      case GamesLayoutType.LAYOUT_3C:
        return <ScreenIcon3C />;
      case GamesLayoutType.LAYOUT_3D:
        return <ScreenIcon3D />;
      case GamesLayoutType.LAYOUT_4:
        return <ScreenIcon4 />;
      default:
        return <ScreenIcon1 />;
    }
  }

  setGameLayout(layout) {
    let count;
    switch (layout) {
      case GamesLayoutType.LAYOUT_2A:
      case GamesLayoutType.LAYOUT_2B:
        count = 2;
        break;
      case GamesLayoutType.LAYOUT_3A:
      case GamesLayoutType.LAYOUT_3B:
      case GamesLayoutType.LAYOUT_3C:
      case GamesLayoutType.LAYOUT_3D:
        count = 3;
        break;
      case GamesLayoutType.LAYOUT_4:
        count = 4;
        break;
      default:
        count = 1;
        break;
    }

    count > 1
      ? this.props.broadcastGameMode("MULTI")
      : this.props.broadcastGameMode("SINGLE");

    this.props.setMultiGame(count, layout);

    this.setState({ collapse: true });
  }

  render() {
    const { t } = this.props;
    return (
      <span className="games-layout">
        <div
          className={`layout-selection-background ${
            this.state.collapse ? "d-none" : ""
          }`}
          onClick={() => {
            this.setState({
              collapse: true,
            });
          }}
        />
        <div
          className="active-layout"
          onClick={() => {
            this.setState({
              collapse: !this.state.collapse,
            });
          }}
        >
          {this.getSelectedIcon(this.props.multiGameLayout)}{" "}
          {this.props.multiGameLayout !== GamesLayoutType.LAYOUT_1
            ? t("multiPlay")
            : t("singlePlay")}{" "}
          {this.state.collapse && <ArrowDown />}
          {!this.state.collapse && <ArrowUp />}
        </div>

        <div
          className={`layout-selection ${
            this.state.collapse ? "collapse-panel" : ""
          }`}
        >
          <div>
            1{" "}
            <span
              className={`icon ${
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_1
                  ? "selected"
                  : ""
              }`}
              data-testid="layout-1-single"
              onClick={() => {
                this.setGameLayout(GamesLayoutType.LAYOUT_1);
              }}
            >
              <ScreenIcon1 />
            </span>
          </div>
          <div>
            2{" "}
            <span
              className={`icon ${
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_2A
                  ? "selected"
                  : ""
              }`}
              data-testid="layout-2-columns"
              onClick={() => {
                this.setGameLayout(GamesLayoutType.LAYOUT_2A);
              }}
            >
              <ScreenIcon2A />
            </span>
            <span
              className={`icon ${
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_2B
                  ? "selected"
                  : ""
              }`}
              data-testid="layout-2-rows"
              onClick={() => {
                this.setGameLayout(GamesLayoutType.LAYOUT_2B);
              }}
            >
              <ScreenIcon2B />
            </span>
          </div>
          <div>
            3{" "}
            <span
              className={`icon ${
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_3A
                  ? "selected"
                  : ""
              }`}
              data-testid="layout-3-a"
              onClick={() => {
                this.setGameLayout(GamesLayoutType.LAYOUT_3A);
              }}
            >
              <ScreenIcon3A />
            </span>
            <span
              className={`icon ${
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_3B
                  ? "selected"
                  : ""
              }`}
              data-testid="layout-3-b"
              onClick={() => {
                this.setGameLayout(GamesLayoutType.LAYOUT_3B);
              }}
            >
              <ScreenIcon3B />
            </span>
            <span
              className={`icon ${
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_3C
                  ? "selected"
                  : ""
              }`}
              data-testid="layout-3-c"
              onClick={() => {
                this.setGameLayout(GamesLayoutType.LAYOUT_3C);
              }}
            >
              <ScreenIcon3C />
            </span>
            <span
              className={`icon ${
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_3D
                  ? "selected"
                  : ""
              }`}
              data-testid="layout-3-d"
              onClick={() => {
                this.setGameLayout(GamesLayoutType.LAYOUT_3D);
              }}
            >
              <ScreenIcon3D />
            </span>
          </div>
          <div>
            4{" "}
            <span
              className={`icon ${
                this.props.multiGameLayout === GamesLayoutType.LAYOUT_4
                  ? "selected"
                  : ""
              }`}
              data-testid="layout-4-grid"
              onClick={() => {
                this.setGameLayout(GamesLayoutType.LAYOUT_4);
              }}
            >
              <ScreenIcon4 />
            </span>
          </div>
        </div>
      </span>
    );
  }
}

export default withNamespaces("translation")(GamesLayout);
